import React from 'react';
import { PropertyDetails } from '../../../core/api/models/project';

interface ProposalProposedCommercialsDetailsCardProps {
    canEditCommercialDetails: any;
    enableEdit: boolean;
    groupedProperties: any[];
    propertyData: any;
    setIsEditProposedCommercials: React.Dispatch<React.SetStateAction<{ isOpen: boolean; data: any; propertiesForProject: PropertyDetails[]; }>>;
    tableWidth?: string;
    marginTop?: string;
}

export default function ProposalProposedCommercialsDetailsCard({ canEditCommercialDetails,
    enableEdit,
    groupedProperties,
    marginTop,
    tableWidth,
    propertyData,
    setIsEditProposedCommercials }: ProposalProposedCommercialsDetailsCardProps) {
    return (
        <table
            width={tableWidth}
            cellPadding="0"
            cellSpacing="0"
        >
            <tbody>
                <tr>
                    <td height={marginTop}></td>
                </tr>
                <tr>
                    <td>
                        <span
                            style={{
                                fontSize: "22px",
                                color: "#8FA9D4",
                                fontWeight: 700,
                            }}
                        >
                            <u>PROPOSED COMMERCIALS</u>
                            {canEditCommercialDetails && enableEdit && <button
                                className="btn btn-outline-primary ml-4 py-1"
                                onClick={() => {
                                    setIsEditProposedCommercials({ isOpen: true, data: propertyData, propertiesForProject: groupedProperties });
                                }}
                            >
                                Edit
                            </button>}
                        </span>
                    </td>
                </tr>
                <tr>
                    <td height="12"></td>
                </tr>

                <tr>
                    <td
                        style={{
                            // padding: "20px",
                            // borderRadius: "12px",
                            // background: `url(${require("../../../assets/images/proposal/box-shadow.png")})`,
                            // backgroundPosition: "bottom 0 center",
                            // backgroundSize: "200%",
                            // backgroundColor: "#F8F5FA",
                            // boxShadow:
                            //   "0 3px 5px 0 rgba(0, 0, 0, 0.2), 0 10px 20px 0 rgba(0, 0, 0, 0.19)",
                            position: "relative",
                        }}
                    >
                        <div style={{ padding: "20px", borderRadius: "12px", position: 'relative', zIndex: 1, backgroundColor: "#F8F5FA", }}>
                            <table
                                width="100%"
                                cellPadding="0"
                                cellSpacing="0"
                            >
                                <tbody>
                                    <tr>
                                        <td width="50%" valign="top">
                                            <ul
                                                // className="row"
                                                style={{
                                                    listStyleType: "none",
                                                    padding: "0",
                                                    marginBottom: "0",
                                                    columns: "2",
                                                }}
                                            >
                                                {propertyData?.commericialDetails?.map(
                                                    (commericialDetails: {
                                                        attrName: string;
                                                        attrOptionValue: string;
                                                    }) => (
                                                        <li
                                                            // className="col-md-6"
                                                            style={{
                                                                color: "#5E5E5E",
                                                                fontSize: "14px",
                                                                marginBottom:
                                                                    "9px",
                                                                lineHeight:
                                                                    "25px",
                                                            }}
                                                        >
                                                            <u
                                                                style={{
                                                                    color:
                                                                        "#00134F",
                                                                }}
                                                            >
                                                                {
                                                                    commericialDetails.attrName
                                                                }{" "}
                                                                :
                                                            </u>{" "}
                                                            {
                                                                commericialDetails.attrOptionValue
                                                            }
                                                        </li>
                                                    )
                                                )}
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {/* <div style={{position: 'absolute', bottom: '-10px', left: '-74px', right: '-38px', zIndex: 0}}>
                                            <img src={bottomShadow} alt="" style={{width: '100%'}} />
                                            </div> */}
                        <div
                            style={{
                                width: "100%",
                                height: "20px",
                                background:
                                    "radial-gradient(black, #000000a3)",
                                position: "absolute",
                                left: "-50%",
                                bottom: "-10px",
                                zIndex: 0,
                                borderRadius: "147px",
                                filter: "blur(7px)",
                                transform:
                                    "translateX(50%) scaleY(0.2)",
                            }}
                        ></div>
                    </td>
                </tr>
            </tbody>
        </table>
    );
}
